<template>
  <div class="d-flex justify-content-center align-items-center">
    <div>
      <b-button
        data-cy="details"
        v-b-modal="`modal-details-${file.idAprobacion}`"
        variant="secondary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        v-on:click="onOptionDetailFlow(file)"
      >
        <feather-icon icon="SearchIcon" />
      </b-button>
    </div>
    <b-dropdown
      v-if="view !== 'masiva' && view !== 'observador'"
      v-has-permission="'ED096'"
      variant="link"
      no-caret
      right
    >
      <template #button-content>
        <feather-icon
          data-cy="gear-button"
          width="24px"
          height="24px"
          icon="SettingsIcon"
          class="align-middle text-body"
        />
      </template>
      <CheckPermission
        permission="ED053"
        v-if="canManageFile
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="target-process"
          v-on:click="onOptionManageFile(file)"
        >
          <feather-icon icon="ShuffleIcon" />
          <span v-if="isOffice">
            Tramitar documento
          </span>
          <span v-if="!isOffice">
            Gestionar documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED108"
        v-if="
        view === 'entrada'
        && file.aprobacionesTipoPasoId.toString() !== '6'
        && file.aprobacionesTipoPasoId.toString() !== '7'
        && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED
      "
      >
        <b-dropdown-item
          data-cy="add-step"
          v-on:click="onOptionAddStep(file)"
          v-b-modal="`modal-add-step-${file.idAprobacion}`"
        >
          <feather-icon icon="UserIcon" />
          <span>
            Agregar paso
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED108"
        v-if="
        view === 'entrada'
        && file.aprobacionesEjecucionEstadoId.toString() === FileStates.PREPARED
        && isAguasAndinas
      "
      >
        <b-dropdown-item
          v-on:click="onVerifiNumerationOpenText(file)"
        >
          <feather-icon icon="UserCheckIcon" />
          <span>
            Verificar si se numeró documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED106"
        v-if="
        view === 'entrada'
        && file.aprobacionesEjecucionEstadoId.toString() === FileStates.PREPARED
        && isAguasAndinas"
      >
        <b-dropdown-item
          data-cy="process-annul"
          v-on:click="onOptionCancelFile(file)"

        >
          <feather-icon icon="XCircleIcon" />
          <span>
            Anular proceso
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED062"
        v-if="view === 'pre-oficina'
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="assign-document"
          v-on:click="onOptionSendFile(file)"
        >
          <feather-icon icon="EditIcon" />
          <span>
            Asignar documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED230"
        v-if="
        this.view === 'entrada' &&
        canRetainFile &&
        isSiss &&
        file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="retain-document"
          v-on:click="onOptionRetainFile(file)"
          v-b-modal="`modal-retain-${file.idAprobacion}`"
        >
          <feather-icon icon="LockIcon" />
          <span>
            Retener documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED235"
        v-if="
        this.view === 'general' &&
        canRetainFile &&
        isSiss &&
        file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="retain-document"
          v-on:click="onOptionRetainFile(file)"
          v-b-modal="`modal-retain-${file.idAprobacion}`"
        >
          <feather-icon icon="LockIcon" />
          <span>
            Retener documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED063"
        v-if="view === 'pre-oficina' && !isGore
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="return-document"
          v-on:click="onOptionReturnFile(file)"
        >
          <feather-icon icon="CornerUpLeftIcon" />
          <span>
            Devolver documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED064"
        v-if="view === 'pre-oficina'
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="resend-document"
          v-on:click="onOptionResendFile(file)"
        >
          <feather-icon icon="TrendingUpIcon" />
          <span>
            Reenviar documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED065"
        v-if="view === 'pre-oficina'
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
      >
        <b-dropdown-item
          data-cy="review-document"
          v-on:click="onOptionManageFilePreOffice(file)"
        >
          <feather-icon icon="ShuffleIcon" />
          <span>
            Revisar documento
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <b-dropdown-item
        data-cy="see-document"
        v-if="seeDocumentOptions.includes(view)"
        v-on:click="onOptionGetFile(file)"
      >
        <feather-icon icon="SearchIcon" />
        <span>
          Ver Documento
        </span>
      </b-dropdown-item>
      <CheckPermission
        permission="ED106"
        v-if="canCancelFile"
      >
        <b-dropdown-item
          data-cy="process-annul"
          v-on:click="onOptionCancelFile(file)"
        >
          <feather-icon icon="XCircleIcon" />
          <span>
            Anular proceso
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED126"
        v-if="
        (view === 'enviados' || view === 'general')
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.APPROVED
          && canBeFile
          && file.transformada !== 'Y'
        "
      >
        <b-dropdown-item
          data-cy="generate-file"
          v-on:click="onOptionConvertToExpedient(file)"
        >
          <feather-icon icon="ArchiveIcon" />
          <span>
            Generar Expediente
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission
        permission="ED107"
        v-if="(view === 'general' || view === 'enviados')
          && (file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED ||
          file.aprobacionesEjecucionEstadoId.toString() === FileStates.PREPARED)"
      >
        <b-dropdown-item
          data-cy="process-dismiss"
          v-on:click="onOptionDisparageFile(file)"
        >
          <feather-icon icon="MinusCircleIcon" />
          <span>
            Desestimar proceso
          </span>
        </b-dropdown-item>
      </CheckPermission>
      <b-dropdown-item
        data-cy="download-attached"
        v-if="view === 'general' || view === 'entrada-jefatura'"
        v-on:click="onOptionAttachmentsFile(file)"
      >
        <feather-icon icon="DownloadIcon" />
        <span>
          Descargar adjuntos
        </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="view === 'enviados' || view === 'general' || view === 'entrada-jefatura' || view === 'salida'"
        v-on:click="onOptionCommentsFile(file)"
        data-cy="see-comment"
      >
        <feather-icon icon="MessageCircleIcon" />
        <span>
          Ver comentarios
        </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="view === 'general' || view === 'entrada-jefatura'"
        v-on:click="onConcecuencesFile(file)"
        data-cy="see-comment"
      >
        <feather-icon icon="PlayIcon" />
        <span>
          Ver consecuencias
        </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="view === 'general' || view === 'entrada-jefatura'"
        v-has-permission="'ED279'"
        v-on:click="onOptionStepsFile(file)"
        data-cy="see-steps"
      >
        <feather-icon icon="GitMergeIcon" />
        <span>
          Ver pasos
        </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="(view === 'general' || view === 'entrada-jefatura')
          && file.aprobacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
        v-has-permission="'ED281'"
        v-on:click="onOptionNotifyExecution(file)"
        data-cy="notify-execution"
      >
        <feather-icon icon="BellIcon" />
        <span>
          Re-notificar
        </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-has-permission="'ED273'"
        v-on:click="onDownloadApprovalFile(file)"
        data-cy="see-approval-file"
      >
        <feather-icon icon="FileIcon" />
        <span>
          Ver acta
        </span>
      </b-dropdown-item>
    </b-dropdown>
    <details-approval :file="file" />
    <b-modal
      :id="`modal-assign-${file.idAprobacion}`"
      :title="`Asignar documento ${file.numero}`"
      no-close-on-backdrop
      :ref="`modal-assign-${file.idAprobacion}`"
      size="lg"
      hide-footer
    >
      <modal-assign-approval
        v-if="file"
        :file="file"
        :officeId="officeId"
        @close="closeModal(file)"
      />
    </b-modal>
    <b-modal
      :id="`modal-return-${file.idAprobacion}`"
      :title="`Devolver documento ${file.numero}`"
      no-close-on-backdrop
      :ref="`modal-return-${file.idAprobacion}`"
      size="lg"
      hide-footer
    >
      <modal-return-approval
        v-if="file"
        :stepId="step"
        :fileId="file.aprobacionesReferenciaId"
        :flowId="file.idAprobacion"
        :action="'return'"
        @close="closeModal(file)"
      />
    </b-modal>
    <b-modal
      :id="`modal-resend-${file.idAprobacion}`"
      :title="`Reenviar documento ${file.numero}`"
      no-close-on-backdrop
      :ref="`modal-resend-${file.idAprobacion}`"
      size="lg"
      hide-footer
    >
      <modal-resend-approval
        v-if="file"
        :stepId="step"
        :fileId="file.aprobacionesReferenciaId"
        :flowId="file.idAprobacion"
        :action="'resend'"
        @close="closeModal(file)"
      />
    </b-modal>
    <b-modal
      :id="`modal-cancel-${file.idAprobacion}`"
      :title="`Anular Proceso ${file.numero}`"
      no-close-on-backdrop
      :ref="`modal-cancel-${file.idAprobacion}`"
      size="lg"
      @close="closeModal(file)"
    >
      <modal-cancel-approval
        v-if="file"
        :file="file"
        :action="'cancel'"
        @close="closeModal(file)"
      />
    </b-modal>
    <b-modal
      id="modal-comments"
      :title="`Comentarios en el Proceso ${file.numero}`"
      no-close-on-backdrop
      ref="modal-comments"
      size="lg"
      hide-footer
    >
      <comments-flow
        v-if="fileOnFlow.detalle && fileOnFlow.detalle.ejecucion"
        :comments="fileOnFlow.detalle.ejecucion.comentarios"
      />
    </b-modal>
    <b-modal
      id="modal-consecuences"
      :title="`Consecuencias en el Proceso ${file.numero}`"
      no-close-on-backdrop
      ref="modal-consecuences"
      size="lg"
      hide-footer
    >
      <modal-consecuences :file="file" :fileOnFlow="fileOnFlow" />
    </b-modal>
    <b-modal
      id="modal-steps"
      :title="`Pasos del Proceso ${file.numero}`"
      no-close-on-backdrop
      ref="modal-steps"
      size="lg"
      hide-footer
    >
      <div v-if="loadingSteps" class="text-center py-3">
        <b-spinner variant="primary" />
      </div>
      <steps
        v-else-if="executionSteps.length"
        :steps="executionSteps"
        :ejecucion="{}"
        :show-participants="true"
        :editable="hasPermission('ED280')"
        :ejecucion-id="file.idAprobacion"
        @email-changed="onEmailChanged"
        @error="onStepActionError"
      />
    </b-modal>
    <b-modal
      :id="`modal-add-step-${file.idAprobacion}`"
      :ref="`modal-add-step-${file.idAprobacion}`"
      title="Agregar paso al proceso"
      ok-title="Agregar Paso"
      hide-footer
      size="lg"
      ok-only
      no-close-on-backdrop
      data-cy="add-step"
    >
      <modal-add-step
        v-if="file && file.idAprobacion"
        :file="file"
        :flowId="file.idAprobacion"
        @close="closeModal(file)"
      />
    </b-modal>
    <modal-retain-file
      v-if="file"
      :file="file"
      :flowId="file.idAprobacion"
      @close="closeModal(file)"
    />
    <modal-verify-doc-number-in-open-text
      ref="modal-verify-doc-number-open-text"
      v-if="file"
      :file="file"
      :flowId="file.idAprobacion"
      @close="closeModal(file)"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { fileFlowDetails, getAttachments, getExecutionSteps } from '@/febos/servicios/api/aprobaciones.api';
import { notifyExecution } from '@/febos/servicios/api/v2.aprobaciones.api';
import CommentsFlow from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/CommentsFlow';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import DetailsApproval from '@/febos/chile/approvals/vistas/modals/DetailsApproval';
import ModalAssignApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalAssignApproval';
import ModalReturnApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalReturnApproval';
import ModalResendApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalResendApproval';
import ModalCancelApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalCancelApproval';
import ModalAddStep from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalAddStep';
import ModalRetainFile from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalRetainFile';
import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import FileStates from '@/febos/chile/approvals/mixins/FileStates';
import ModalVerifyDocNumberInOpenText
from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalVerifyDocNumberInOpenText';
import ModalConsecuences from '@/febos/chile/approvals/components/trays/managementTray/modals/ModalConsecuences';

export default {
  components: {
    CommentsFlow,
    Steps,
    DetailsApproval,
    ModalAssignApproval,
    ModalResendApproval,
    ModalReturnApproval,
    ModalCancelApproval,
    ModalVerifyDocNumberInOpenText,
    ModalAddStep,
    ModalRetainFile,
    CheckPermission,
    ModalConsecuences
  },
  mixins: [FileStates],
  data() {
    return {
      FileStates,
      view: this.$route.params.view,
      officeId: '',
      action: '',
      loadingSteps: false,
      executionSteps: [],
      seeDocumentOptions: ['general', 'enviados', 'salida', 'pre-oficina', 'entrada-jefatura']
    };
  },
  props: [
    'file',
    'selectFile'
  ],
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow'
    ]),
    ...mapGetters('Empresas', [
      'company',
      'groupsCompany'
    ]),
    ...mapGetters('Usuario', ['currentUserId', 'hasPermission']),
    isGore() {
      return this.company.iut === '72235100-2';
    },
    canRetainFile() {
      return this.file.retenido !== 'Y'
        && this.file.suplente === '';
    },
    canManageFile() {
      return this.view === 'entrada' || this.view === 'entrada-movil'
        || this.view === 'pre-oficina' || this.view === 'tramitar-numerar';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    step() {
      const { detalle = {} } = this.fileOnFlow;
      const {
        pasos = [],
        ejecucion
      } = detalle;
      return this.fileOnFlow.detalle && pasos.find((step) => step.id === ejecucion.pasoActualId);
    },
    isOffice() {
      return (this.file.aprobacionesTipoPasoId || '').toString() === '6'
        || (this.file.aprobacionesTipoPasoId || '').toString() === '7';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    canCancelFile() {
      return !this.isSiss && (this.view === 'enviados' || this.view === 'general')
        && this.file.aprobacionesEjecucionEstadoId.toString() === FileStates.APPROVED;
    },
    canBeFile() {
      return this.file.tipoObjetoId !== 'EXP';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
      'getFileBinnacle',
      'getApprovalManagedFile',
      'attemptDisparageFlow'
    ]),
    ...mapActions('Empresas', [
      'getGroupsCompany'
    ]),
    async onOptionDetailFlow(file) {
      this.selectFile(file);
      try {
        await Promise.all([
          this.getApprovalFileDetails({
            aprobacionId: file.aprobacionesReferenciaId,
            ejecucionId: file.idAprobacion
          }),
          this.getAttachmentFiles({
            aprobacionId: file.aprobacionesReferenciaId,
            ejecucionId: file.idAprobacion
          }),
          this.getFileBinnacle({
            documentoId: file.idAprobacion
          })
        ]);
      } catch (error) {
        console.error(error);
      }
    },
    onOptionManageFile(file) {
      this.selectFile(file);
      this.$router.push(
        {
          name: 'manage-file-tray',
          params: {
            fileId: file.aprobacionesReferenciaId,
            flowId: file.idAprobacion
          }
        }
      );
    },
    onOptionConvertToExpedient(file) {
      this.$router.push(
        {
          name: 'conventionInputForm',
          params: {
            file
          }
        }
      );
    },
    onOptionManageFilePreOffice(file) {
      this.selectFile(file);
      this.$router.push(
        {
          name: 'manage-file-pre-tray',
          params: {
            fileId: file.aprobacionesReferenciaId,
            flowId: file.idAprobacion
          }
        }
      );
    },
    async onOptionAddStep(file) {
      this.selectFile(file);
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion,
        retornarPdf: 'no'
      });
    },
    onVerifiNumerationOpenText(file) {
      this.selectFile(file);
      this.$refs['modal-verify-doc-number-open-text'].verifyDocNumberInOpenText();
    },
    onOptionSendFile(file) {
      this.selectFile(file);
      this.$refs[`modal-assign-${file.idAprobacion}`].show();
    },
    onOptionRetainFile(file) {
      this.selectFile(file);
    },
    async onOptionResendFile(file) {
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion
      });
      await this.getGroupsCompany({
        empresaId: this.company.id
      });
      this.$refs[`modal-resend-${file.idAprobacion}`].show();
    },
    async onOptionReturnFile(file) {
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion
      });
      this.selectFile(file);
      this.$refs[`modal-return-${file.idAprobacion}`].show();
    },
    async canDownloadDoc(file) {
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion
      });
      const authorFlowId = this.fileOnFlow.detalle.ejecucion.usuarioId;
      const currentUserInSteps = this.fileOnFlow.detalle.pasos
        .some((step) => step.paso.tipoValorResponsableId === this.currentUserId
          // eslint-disable-next-line max-len
          || step.paso.grupoUsuarios?.some((user) => user.tipoValorResponsableId === this.currentUserId));

      if (this.fileOnFlow.detalle.ejecucion.privado === 'Y') {
        if (this.currentUserId === authorFlowId || currentUserInSteps) {
          return true;
        }
        return false;
      }
      return true;
    },
    async onOptionGetFile(file) {
      const canDownload = await this.canDownloadDoc(file);
      if (canDownload) {
        this.getApprovalManagedFile({
          aprobacionId: file.aprobacionesReferenciaId,
          ejecucionId: file.idAprobacion
        });
      } else {
        this.$bvToast.toast(
          'El flujo para este documento está marcado como privado',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    onOptionCancelFile(file) {
      this.selectFile(file);
      this.$refs[`modal-cancel-${file.idAprobacion}`].show();
    },
    onOptionDisparageFile(file) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Desestimar flujo!',
        text: `¿Está seguro de desestimar el flujo #${file.numero} ${file.nombre}? `
          + 'Al desestimar no desencadena procesos secundarios, solo la deja sin acción.',
        accept: async () => {
          await this.attemptDisparageFlow({
            aprobacionId: file.aprobacionesReferenciaId,
            ejecucionId: file.idAprobacion
          });
          await this.$bvToast.toast(
            'Se ha desestimado el flujo con éxito',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        },
        cancelText: 'Cancelar',
        acceptText: 'Confirmar'
      });
    },
    async onOptionAttachmentsFile(file) {
      const canDownload = await this.canDownloadDoc(file);
      if (canDownload) {
        this.$bvToast.toast(
          'Estamos bucando los adjuntos en este flujo para ti',
          {
            title: '¡Danos unos segundos!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 5000
          }
        );
        const response = await getAttachments({
          aprobacionId: file.aprobacionesReferenciaId,
          ejecucionId: file.idAprobacion,
          retornarComoZip: 'Y'
        });
        await window.open(response.data.rutaArchivosComprimidos, '_blank');
      } else {
        this.$bvToast.toast(
          'El flujo para este documento está marcado como privado',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async onOptionCommentsFile(file) {
      this.selectFile(file);
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion,
        retornarPdf: 'no'
      });
      this.$refs['modal-comments'].show();
    },
    async onDownloadApprovalFile(file) {
      const response = await fileFlowDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion,
        retornarPdf: 'si'
      });
      window.open(response.data.pdfUrl, '_blank');
    },
    async onConcecuencesFile(file) {
      this.selectFile(file);
      await this.getApprovalFileDetails({
        aprobacionId: file.aprobacionesReferenciaId,
        ejecucionId: file.idAprobacion,
        retornarPdf: 'no'
      });
      this.$refs['modal-consecuences'].show();
    },
    async onOptionStepsFile(file) {
      this.selectFile(file);
      this.loadingSteps = true;
      this.executionSteps = [];
      this.$refs['modal-steps'].show();
      try {
        const response = await getExecutionSteps(file.idAprobacion);
        this.executionSteps = response.data.pasos || [];
      } finally {
        this.loadingSteps = false;
      }
    },
    onEmailChanged() {
      this.$bvToast.toast(
        'Correo actualizado correctamente',
        {
          title: '¡Genial!',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000
        }
      );
    },
    onStepActionError() {
      this.$bvToast.toast(
        'No se pudo realizar la acción, intente nuevamente',
        {
          title: '¡Oops!',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        }
      );
    },
    async onOptionNotifyExecution(file) {
      try {
        this.$bvToast.toast(
          'Solicitando notificar la ejecución de este proceso, por favor espera un momento',
          {
            title: '¡Momento!',
            variant: 'warning',
            solid: true,
            autoHideDelay: 3000
          }
        );
        await notifyExecution(file.idAprobacion);
        this.$bvToast.toast(
          'Se ha re-notificado la ejecución correctamente',
          {
            title: '¡Genial!',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          }
        );
      } catch (error) {
        this.$bvToast.toast(
          'No se pudo re-notificar, intente nuevamente',
          {
            title: '¡Oops!',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          }
        );
      }
    },
    closeModal(file) {
      if (this.$refs[`modal-assign-${file.idAprobacion}`]) {
        this.$refs[`modal-assign-${file.idAprobacion}`].hide();
      }
      if (this.$refs[`modal-cancel-${file.idAprobacion}`]) {
        this.$refs[`modal-cancel-${file.idAprobacion}`].hide();
      }
      if (this.$refs[`modal-return-${file.idAprobacion}`]) {
        this.$refs[`modal-return-${file.idAprobacion}`].hide();
      }

      if (this.$refs[`modal-resend-${file.idAprobacion}`]) {
        this.$refs[`modal-resend-${file.idAprobacion}`].hide();
      }
      if (this.$refs[`modal-add-step-${file.idAprobacion}`]) {
        this.$refs[`modal-add-step-${file.idAprobacion}`].hide();
      }
    }
  }
};

</script>
